import { QueryClient } from "react-query";

const queryConfig = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false,
    cacheTime: 6000
  }
}


export const queryClient = new QueryClient({ defaultOptions: queryConfig })

// eslint-disable-next-line no-undef
export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;

// eslint-disable-next-line no-undef
export const BACKEND_URL = process.env.REACT_APP_API_URL;
export const STAKE_BACKEND_URL = process.env.REACT_APP_STAKE_API_URL;




// eslint-disable-next-line no-undef
export const REACT_APP_CURRENT_TIME_URL = process.env.REACT_APP_CURRENT_TIME_URL;



